import { render, staticRenderFns } from "./invStatus.vue?vue&type=template&id=cf13a7cc&scoped=true&"
import script from "./invStatus.vue?vue&type=script&lang=js&"
export * from "./invStatus.vue?vue&type=script&lang=js&"
import style0 from "./invStatus.vue?vue&type=style&index=0&id=cf13a7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf13a7cc",
  null
  
)

export default component.exports